import React from "react";

const PersonalDataConsent = () => (
  <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
    <tbody>
      <tr>
        <td style={{ paddingLeft: 0 }} colSpan={11}>
          <div
            style={{
              fontWeight: "bold",
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            (D) PERSONAL DATA CONSENT(S)
          </div>
          <div style={{ paddingBottom: 10 }}>
            On behalf of myself and my dependants, I/we consent to Aviva (and Aviva related group of
            companies) collecting, using and/or disclosing my/our personal data to issue and
            administer my existing and/or new policies or insurance coverage(s) with Aviva.
            <br />
            <br />
            On behalf of myself and my dependents, I/we also consent to Aviva (and Aviva related
            group of companies) transferring my/our personal data to Aviva related group of
            companies and/or third party service providers, reinsurers, suppliers or intermediaries,
            whether located in Singapore or elsewhere, for the above purposes.
            <br />
            <br />
            For full details of the purposes of collection, use and disclosure of your personal
            data, please visit{" "}
            <a href="http://www.aviva.com.sg/pdpa.html" target="_blank" rel="noopener noreferrer">
              http://www.aviva.com.sg/pdpa.html
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
);

export default PersonalDataConsent;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/AVIVAHD201910/PersonalDataConsent.js